// extracted by mini-css-extract-plugin
export default {"lazyImg":"index-module_lazyImg_f7c972ca"};